module.exports = __webpack_public_path__ + "img/dep_grocery@2x.8a726082.png";